export const GAMES_ENABLED = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get("free") === "paid" : false;
export const QA_MODE = typeof window !== 'undefined' ? window.location.pathname.includes('demo') : false;

export const getUserId = () => {
  if(typeof window === 'undefined') return "";
  return new URLSearchParams(window.location.search).get("userId") || "";
}

export const getQueryPath = () => {
  if(typeof window === 'undefined') return "";
  return new URLSearchParams(window.location.search).get("queryPath") || "";
}